import type { IMedia } from "../../../model/unityObject";
import ImageCard from "../../gallery/components/ImageCard";
import type { ControllerRenderProps } from "react-hook-form";
import { useEffect } from "react";
import type { menuItem, menuItems } from "../../../common/components/Icon/ThreeDotsDropdownMenu";
import type { ICustomRemoveButton } from "src/common/components/CustomXIcon/CustomXIcon";
import { MediaLoadingCard } from "../../gallery/components/MediaLoadingCard";

export const MediaSelector = ({
  handleButtonClick,
  media,
  currentMedia,
  field,
  customMenuItems,
  disabled = false,
  CustomRemoveButton,
  className = undefined,
  showThreeDotsMenu = true,
  isLoading = false,
  loadError = false,
  onRetryLoad,
}: {
  field: ControllerRenderProps;
  handleButtonClick: (mediaId: number, item: menuItem | null, index: number) => void;
  media: IMedia;
  currentMedia: number | undefined;
  customMenuItems?: menuItems;
  disabled?: boolean;
  CustomRemoveButton?: ICustomRemoveButton;
  className?: string;
  showThreeDotsMenu?: boolean;
  isLoading?: boolean;
  loadError?: boolean;
  onRetryLoad?: () => void;
}) => {
  useEffect(() => {
    if (currentMedia !== field.value) {
      field.onChange(currentMedia);
    }
  }, [currentMedia]);

  const is3DEnvironment = field.name === "source_model3d";

  if (isLoading || loadError) {
    return <MediaLoadingCard className={className} error={loadError} onRetry={onRetryLoad} />;
  }

  return (
    <ImageCard
      handleButtonClick={(mediaId: number, item: menuItem, index: number) =>
        handleButtonClick(mediaId, item, index)
      }
      handleCardClick={() => {
        handleButtonClick(0, null, 0);
      }}
      isMediaPickerMode={false}
      currentMedia={currentMedia}
      media={media}
      customMenuItems={customMenuItems}
      disabled={disabled}
      showThreeDotsMenu={showThreeDotsMenu}
      CustomRemoveButton={is3DEnvironment ? CustomRemoveButton : undefined}
      className={className}
    />
  );
};
